export default __webpack_public_path__ + "static/media/add_icon-step3.36141c67.svg";